import React, { useState } from "react";
import Page from 'src/components/Page';
import { useNavigate } from 'react-router';
import { getUser } from 'src/utils/Common';

const styles = {};
function HVACReport() {
  const navigate = useNavigate();
  const [roleTypes, setRoleTypes] = useState(0);
  const [loading, setLoading] = useState(false);
  const SessionUser = getUser();
  


  return (
    <Page
      sx={styles.root}
      title={"Enerji Çözümleri"}
    >
      Raporlar
    </Page>
  );
}

export default HVACReport;
